import { css } from 'lit';
export const radioGroupOptionStyles = css `
    :host {
        display: block;
    }

    .hlx-radio-option {
        display: flex;
        align-items: flex-start;
    }

    .hlx-radio-option-control {
        cursor: pointer;
        position: relative;
        appearance: none;
        display: inline-block;
        width: var(--hlx-spacing-lg);
        height: var(--hlx-spacing-lg);
        border: 1px solid var(--hlx-input-border-color-default);
        border-radius: 50%;
        margin: 0;
        flex-shrink: 0;
    }

    .hlx-radio-option-control:checked::after {
        content: '';
        display: block;
        position: absolute;
        top: calc((var(--hlx-spacing-lg) - var(--hlx-spacing-xs) - 2px) / 2);
        left: calc((var(--hlx-spacing-lg) - var(--hlx-spacing-xs) - 2px) / 2);
        width: var(--hlx-spacing-xs);
        height: var(--hlx-spacing-xs);
        background: var(--hlx-color-brand-default);
        border-radius: 50%;
    }

    .hlx-radio-option:hover .hlx-radio-option-control,
    .hlx-radio-option-control:hover {
        border-width: 2px;
    }

    .hlx-radio-option-control:focus {
        border-width: 2px !important;
        border-color: var(--hlx-color-brand-default) !important;
        outline: none;
    }
    /* prevent shift when border is wider */
    .hlx-radio-option-control:checked:focus::after,
    .hlx-radio-option-control:checked:hover::after,
    .hlx-radio-option:hover .hlx-radio-option-control:checked::after {
        top: calc((var(--hlx-spacing-lg) - var(--hlx-spacing-xs) - 4px) / 2);
        left: calc((var(--hlx-spacing-lg) - var(--hlx-spacing-xs) - 4px) / 2);
    }

    .hlx-radio-option-legend {
        cursor: pointer;
        padding-left: var(--hlx-spacing-md);
    }

    .hlx-radio-option-show-label .hlx-radio-option-label {
        display: block;
    }
    .hlx-radio-option-label {
        color: var(--hlx-input-label-color-default);
        font-weight: var(--hlx-text-font-weight-medium);
        margin-bottom: var(--hlx-spacing-2xs);
    }
    .hlx-radio-option-show-description .hlx-radio-option-description {
        display: block;
    }
    .hlx-radio-option-description {
        color: var(--hlx-input-help-text-color);
        font-weight: var(--hlx-text-font-weight-normal);
    }

    .hlx-radio-option.hlx-radio-option-disabled,
    .hlx-radio-option.hlx-radio-option-disabled .hlx-radio-option-legend,
    .hlx-radio-option.hlx-radio-option-disabled .hlx-radio-option-label,
    .hlx-radio-option.hlx-radio-option-disabled .hlx-radio-option-description,
    .hlx-radio-option.hlx-radio-option-disabled .hlx-radio-option-control {
        cursor: not-allowed;
        color: var(--hlx-input-text-color-disabled);
    }

    /* disable hover effects for disabled items */
    .hlx-radio-option.hlx-radio-option-disabled:hover .hlx-radio-option-control,
    .hlx-radio-option.hlx-radio-option-read-only:hover .hlx-radio-option-control {
        border-width: 1px;
    }
    .hlx-radio-option.hlx-radio-option-disabled:hover .hlx-radio-option-control:checked::after,
    .hlx-radio-option.hlx-radio-option-read-only:hover .hlx-radio-option-control:checked::after {
        top: calc((var(--hlx-spacing-lg) - var(--hlx-spacing-xs) - 2px) / 2);
        left: calc((var(--hlx-spacing-lg) - var(--hlx-spacing-xs) - 2px) / 2);
    }

    .hlx-radio-option-show-appendix + .hlx-appendix-box {
        display: block;
    }
    .hlx-appendix-box {
        padding-left: calc(var(--hlx-spacing-lg) + var(--hlx-spacing-md));
        margin-top: var(--hlx-spacing-2xs);
    }
    ::slotted(hlx-text-field::part(hlx-form-control)) {
        border: 2px solid red;
        margin: 0;
    }
`;
//# sourceMappingURL=radio-group-option.styles.js.map